import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);
const em = (chunks: React.ReactNode) => (
    <em>
        {chunks}
    </em>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <>
                    <p>
                        <FormattedMessage defaultMessage="Use the search box above the table to find tests by <strong>name</strong>, <strong>program</strong>, or <strong>creator</strong>. Results update automatically as you type." id="use_the_search_box_above_the_table_to_fi.06b8ba11" values={{ strong }} />
                    </p>
                    <p>
                        <FormattedMessage defaultMessage="Open the <em>Filters</em> menu to toggle <strong>Only My Tests</strong> (all tests are shown by default — turn this on to see just the tests you created) and <strong>Archived Tests</strong> (includes archived tests in the results, marked with an <em>Archived</em> badge)." id="open_the_filters_menu_to_toggle_only_my.e3067579" values={{ em, strong }} />
                    </p>
                </>
            ),
            title: <FormattedMessage defaultMessage="Searching and Filtering" id="searching_and_filtering.d970350d" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>New Custom Test</strong> to open the builder. Pick a category and programs, add questions manually or with Smart Build, then review the settings and save." id="click_new_custom_test_to_open_the_builde.b32e3556" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating a Test" id="creating_a_test.b332a7c5" />
        },
        {
            body: (
                <>
                    <p>
                        <FormattedMessage defaultMessage="Every row offers <strong>View</strong> to open the test details and <strong>Copy</strong> to create your own editable copy of any test — the original is never changed." id="every_row_offers_view_to_open_the_test_d.2c1666f4" values={{ strong }} />
                    </p>
                    <p>
                        <FormattedMessage defaultMessage="Tests you own also offer <strong>Assign</strong> (deliver the test to classrooms or access codes) and <strong>Archive</strong> or <strong>Restore</strong>. Archived tests cannot be assigned until they are restored." id="tests_you_own_also_offer_assign_deliver.0f9c5c1d" values={{ strong }} />
                    </p>
                </>
            ),
            title: <FormattedMessage defaultMessage="Row Actions" id="row_actions.f09b3e3a" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>Switch to classic view</strong> link at the top of the page to return to the original Custom Tests experience at any time." id="use_the_switch_to_classic_view_link_at_t.fbe9cc97" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Classic View" id="classic_view.e16c6368" />
        }
    ],
    title: <FormattedMessage defaultMessage="Custom Tests" id="custom_tests.9e7494ea" />
};
